export default __webpack_public_path__ + "static/media/GCED_flat_mockup.71d1aa67.png";